
import axios from '../../config/axiosConfig';
import { 
    CREATE_PIPE_OPENING, 
    GET_PIPE_OPENINGS, 
    PIPE_OPENING_REQUEST, 
    DELETE_PIPE_OPENING, 
    UPDATE_PIPE_OPENING, 
    PIPE_OPENING_REQUEST_FAILURE, 
    GET_PIPE_OPENINGS_PAGE, 
    PIPE_OPENING_REQUEST_SUCCESS 
} from '../types';

export const getValidatedIncrementedVchNoPipeOpening = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/pipe-opening/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getPipeOpeningWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_OPENING_REQUEST });
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Item,Account,Vehicle,PipeType'
      };
      return axios.get("/pipe-opening/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_PIPE_OPENINGS_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getPipeOpenings = (include) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_OPENING_REQUEST });
            const { auth } = getState();
            let params = {
                finyearId: auth.finyear?.id,
                companyId: auth.company?.id,
                customerId: auth?.user?.Customer_Id
            };
            if (include) {
                params = { ...params, include };
            }
            return axios.get('/pipe-opening/get', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_PIPE_OPENINGS, payload: response.data?.data || [] });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getPipeOpeningById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PIPE_OPENING_REQUEST });
    
      return axios.get(`/pipe-opening/get/${id}`).then((response) => {
        dispatch({ type: PIPE_OPENING_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
    }
  };
};


export const getPartyPipeBalance = (accountId) => {
  return async (dispatch, getState) => {
    try {
    //    dispatch({ type: PIPE_OPENING_REQUEST });
       const { auth } = getState();
       let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
       };
       if (accountId) {
        params = { ...params, accountId };
       }
    
      return axios.get(`/pipe-opening/get-party-pipe-balance`, { params }).then((response) => {
        // dispatch({ type: PIPE_OPENING_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        // dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
    //   dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const createPipeOpening = (pipeOpening) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: PIPE_OPENING_REQUEST });
            axios.post('/pipe-opening/add', pipeOpening,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id, finyearId: auth.finyear?.id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_PIPE_OPENING, payload: response.data });
                    } else {
                        dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: 'Pipe Opening create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updatePipeOpening = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: PIPE_OPENING_REQUEST });
            return axios.put('/pipe-opening/update', { id, data }).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_PIPE_OPENING, payload: { id, data: response.data } }, { params: { userId: auth.user?.id }});
                } else {
                    dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: 'Pipe Opening update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deletePipeOpening = (id) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: PIPE_OPENING_REQUEST });
            axios.delete(`/pipe-opening/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_PIPE_OPENING, id: id });
                    const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Item_Id', 'Receive_Pipe', 'Ends', 'Vehicle_Id', 'Pipe_Type_Id', 'Remark'].join(',');
                    const searchCols = ['Vch_No', 'Date', 'Account_Id', 'Item_Id', 'Receive_Pipe', 'Ends', 'Vehicle_Id', 'Pipe_Type_Id', 'Remark'].join(',');
                    const { inventory: { pipeOpening: { page, pageSize, search, where } = {} } } = getState();
                    dispatch(getPipeOpeningWithPagination(page, pageSize, include, search, searchCols, where, true));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: PIPE_OPENING_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};